import { render } from "./ProposalDashboard.vue?vue&type=template&id=4fc7fee8"
import script from "./ProposalDashboard.vue?vue&type=script&lang=js"
export * from "./ProposalDashboard.vue?vue&type=script&lang=js"

import "./ProposalDashboard.vue?vue&type=style&index=0&id=4fc7fee8&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__